import script from "./BackSheetDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BackSheetDialog.vue?vue&type=script&setup=true&lang=js"

import "./BackSheetDialog.vue?vue&type=style&index=0&id=00eb70c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00eb70c6"]])

export default __exports__